import { render, staticRenderFns } from "./duoShare.vue?vue&type=template&id=65b67b56&scoped=true&"
import script from "./duoShare.vue?vue&type=script&lang=js&"
export * from "./duoShare.vue?vue&type=script&lang=js&"
import style0 from "./duoShare.vue?vue&type=style&index=0&id=65b67b56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b67b56",
  null
  
)

export default component.exports